/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { OnInit, ViewChild } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';

// tslint:disable-next-line:no-shadowed-variable
export abstract class AbstractBlock<AbstractEntityBlock> implements OnInit {
  @ViewChild(CdkPortal, { static: true }) private portal: CdkPortal;
  block: AbstractEntityBlock;

  ngOnInit(): void {
    // if (!this.portal) {
    //   throw new Error(`Each element should have an options' portal, add *cdkPortal inside of HTML block.`);
    // }
  }
}

export abstract class AbstractEntityBlock {}
